<script lang="ts" setup>
import { useDialog, useHelper } from '@/composeables';
import IconComp from '../IconComp.vue';
import type { Component } from 'vue';

const props = withDefaults(
    defineProps<{
        value: any; // TODO: Maybe should define a type for this atleast we need to know if it has a details property and that property should probably be a more generic type maybe a key value pair with messages.

        view?: Component | null;
    }>(),
    { value: null, view: null },
);

const showdetails = (e: Event) => {
    useHelper().stopPropagation(e);

    if (props.view != null) {
        useDialog().Ok({
            title: 'general.details',
            body: props.view as new (...args: any[]) => Component, // I dont want this as, but the type inference is being difficult
            componentProps: { details: props.value.details },
            options: { Size: 'md' },
        });
    }
};
</script>

<template>
    <div class="fs-6">
        <a
            v-if="$props.value != null && props.value.details"
            href="#"
            class="inverted"
            :title="$tm('general.showdetails')"
            @click.capture="showdetails"
        >
            <IconComp icon="fa-memo-circle-info" />
        </a>
    </div>
</template>
